import { render } from "./Embaixadores.vue?vue&type=template&id=8c5c6106"
import script from "./Embaixadores.vue?vue&type=script&lang=js"
export * from "./Embaixadores.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__